'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.View = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _list = require('list');

var _list2 = _interopRequireDefault(_list);

var _base = require('base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangeList = function (_ListBox) {
	_inherits(RangeList, _ListBox);

	function RangeList() {
		_classCallCheck(this, RangeList);

		return _possibleConstructorReturn(this, (RangeList.__proto__ || Object.getPrototypeOf(RangeList)).apply(this, arguments));
	}

	_createClass(RangeList, [{
		key: 'map',
		value: function map(index) {
			return index;
		}
	}, {
		key: 'options',
		value: function options() {
			var start = this.startRange,
			    end = this.endRange,
			    incr = this.incr,
			    result = [{ _asEmpty: true, id: "Rdefault", data: null, value: this.defaultValueLabel }];
			for (var i = start; incr < 0 ? i >= end : i <= end; i += incr) {
				result.push({
					id: "R" + i,
					data: i,
					value: this.map(i)
				});
			}
			return result;
		}
	}, {
		key: 'getValue',
		value: function getValue() {
			if (this.props.value) return { id: 'R' + this.props.value };
			return { id: 'Rdefault' };
		}
	}, {
		key: 'startRange',
		get: function get() {}
	}, {
		key: 'endRange',
		get: function get() {}
	}, {
		key: 'defaultValueLabel',
		get: function get() {}
	}, {
		key: 'incr',
		get: function get() {
			return 1;
		}
	}]);

	return RangeList;
}(_list2.default);

var MonthList = function (_RangeList) {
	_inherits(MonthList, _RangeList);

	function MonthList() {
		_classCallCheck(this, MonthList);

		return _possibleConstructorReturn(this, (MonthList.__proto__ || Object.getPrototypeOf(MonthList)).apply(this, arguments));
	}

	_createClass(MonthList, [{
		key: 'map',
		value: function map(index) {
			return MonthList.monthName(index);
		}
	}, {
		key: 'startRange',
		get: function get() {
			return 1;
		}
	}, {
		key: 'endRange',
		get: function get() {
			return 12;
		}
	}, {
		key: 'defaultValueLabel',
		get: function get() {
			return 'Month';
		}
	}], [{
		key: 'monthName',
		value: function monthName(month) {
			var d = new Date('January 1 2001 12:00:00');
			d.setMonth(month - 1);
			return d.format('F');
		}
	}]);

	return MonthList;
}(RangeList);

var DateList = function (_RangeList2) {
	_inherits(DateList, _RangeList2);

	function DateList() {
		_classCallCheck(this, DateList);

		return _possibleConstructorReturn(this, (DateList.__proto__ || Object.getPrototypeOf(DateList)).apply(this, arguments));
	}

	_createClass(DateList, [{
		key: 'startRange',
		get: function get() {
			return 1;
		}
	}, {
		key: 'endRange',
		get: function get() {
			if (this.props.year && this.props.month) {
				var d = new Date('January 1 2001 12:00:00');
				d.setFullYear(this.props.year);
				d.setMonth(this.props.month); // first day of next month
				d.setDate(0);
				return d.getDate(); // Last day of specified month
			}
			return 31;
		}
	}, {
		key: 'defaultValueLabel',
		get: function get() {
			return 'Date';
		}
	}]);

	return DateList;
}(RangeList);

var YearList = function (_RangeList3) {
	_inherits(YearList, _RangeList3);

	function YearList() {
		_classCallCheck(this, YearList);

		return _possibleConstructorReturn(this, (YearList.__proto__ || Object.getPrototypeOf(YearList)).apply(this, arguments));
	}

	_createClass(YearList, [{
		key: 'endRange',
		get: function get() {
			return new Date().getFullYear() + (this.props.future ? 1 : -1) * 70;
		}
	}, {
		key: 'startRange',
		get: function get() {
			return new Date().getFullYear();
		}
	}, {
		key: 'incr',
		get: function get() {
			return this.props.future ? 1 : -1;
		}
	}, {
		key: 'defaultValueLabel',
		get: function get() {
			return 'Year';
		}
	}]);

	return YearList;
}(RangeList);

var DateField = function (_BaseField) {
	_inherits(DateField, _BaseField);

	_createClass(DateField, null, [{
		key: 'value',
		value: function value(date, properties) {
			if (!properties) properties = {};
			if (date) {
				var d = date.split('-');
				return {
					year: Number(d[0]),
					month: Number(d[1]),
					date: Number(d[2]),
					specified: properties.specified || 'date'
				};
			}
			return null;
		}
	}, {
		key: 'updateValue',
		value: function updateValue(dateUpdater, propertiesUpdater) {
			return function (dateValue) {
				if (dateValue) {
					var d = [Number(dateValue.year)];
					if (dateValue.specified != 'year') {
						d.push(Number(dateValue.month));
						if (dateValue.specified != 'month') {
							d.push(Number(dateValue.date));
						} else {
							d.push(1);
						}
					} else {
						d.push(1, 1);
					}
					if (this.props.withoutYear) {
						var x = new Date('January 1 2001');
						x.setFullYear(new Date().getFullYear());
						x.setMonth(d[1] - 1);
						x.setDate(d[2]);
						if (x < new Date()) x.setFullYear(new Date().getFullYear() + 1);
						d[0] = x.getFullYear();
					}
					d = d.map(function (v, i) {
						return ('0000' + String(v)).substr(i == 0 ? -4 : -2);
					}).join('-');
					dateUpdater(d);
					propertiesUpdater({ specified: dateValue.specified || 'date' });
					return;
				}
				dateUpdater(null);
				propertiesUpdater({ specified: 'none' });
			};
		}
	}, {
		key: 'nextID',
		value: function nextID() {
			var c = this.idCounter;
			if (c === void 0) this.idCounter = c = 1;
			this.idCounter++;
			return 'date-field-' + c;
		}
	}]);

	function DateField(props) {
		_classCallCheck(this, DateField);

		var _this5 = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, props));

		var dv = Object.assign({
			specified: _this5.props.withoutYear ? 'year' : 'none',
			month: null,
			date: null,
			year: _this5.props.withoutYear ? new Date().getFullYear() : null
		}, (typeof value == 'string' ? DateField.value(_this5.props.value) : _this5.props.value) || {}, _this5.props.withoutYear ? {
			year: new Date().getFullYear(),
			ignoreYear: true
		} : {});

		if (_this5.props.withoutYear && (!dv.specified || dv.specified == 'none')) dv.specified = 'year';

		if (dv.specified == 'none') dv = Object.assign(dv, { month: null, date: null, year: null });else if (dv.specified == 'year') dv = Object.assign(dv, { month: null, date: null });else if (dv.specified == 'month') dv = Object.assign(dv, { date: null });

		if (_this5.props.withoutYear && dv.specified == 'date') {
			var x = new Date('January 1 2001');
			x.setFullYear(new Date().getFullYear());
			x.setMonth(dv.month - 1);
			x.setDate(dv.date);
			if (x < new Date()) dv.year = 1 + new Date().getFullYear();
		}
		_this5.state = Object.assign(_this5.state, { monthField: _this5.constructor.nextID(), inputDate: dv });
		return _this5;
	}

	_createClass(DateField, [{
		key: 'render',
		value: function render() {
			var _this6 = this;

			return React.createElement(
				'div',
				{ className: 'dateField ' + (this.props.asRow ? 'label-row' : '') },
				React.createElement(
					'span',
					{ className: this.props.labelOutside || this.props.asRow ? '' : 'sr-only' },
					React.createElement(
						'span',
						null,
						this.props.label
					)
				),
				React.createElement(MonthList, { className: 'date-month', value: this.getMonth(), hideLabel: true, label: 'Month', setValue: function setValue(value) {
						return _this6.setMonth((value || { data: null }).data);
					} }),
				this.props.hasDate ? React.createElement(DateList, { className: 'date-day', month: this.getMonth(), year: this.getYear(), label: 'Date', value: this.getDate(), hideLabel: true, setValue: function setValue(value) {
						return _this6.setDate((value || { data: null }).data);
					} }) : null,
				this.props.withoutYear ? null : React.createElement(YearList, { className: 'date-year', value: this.getYear(), hideLabel: true, label: 'Year', setValue: function setValue(value) {
						return _this6.setYear((value || { data: null }).data);
					} })
			);
		}
	}, {
		key: 'getSpecified',
		value: function getSpecified() {
			return this.state.inputDate.specified;
		}
	}, {
		key: 'getMonth',
		value: function getMonth() {
			return this.state.inputDate.month;
		}
	}, {
		key: 'getDate',
		value: function getDate() {
			return this.state.inputDate.date;
		}
	}, {
		key: 'getYear',
		value: function getYear() {
			return this.state.inputDate.year;
		}
	}, {
		key: 'setMonth',
		value: function setMonth(value) {
			this.setValue(Object.assign({}, this.state.inputDate, { month: value || null }));
		}
	}, {
		key: 'setDate',
		value: function setDate(value) {
			this.setValue(Object.assign({}, this.state.inputDate, { date: value || null }));
		}
	}, {
		key: 'setYear',
		value: function setYear(value) {
			this.setValue(Object.assign({}, this.state.inputDate, { year: value || null }));
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var upValue = Object.assign({}, value);
			if (upValue.year) {
				if (upValue.month) {
					if (upValue.date) {
						upValue.specified = 'date';
					} else {
						upValue.specified = 'month';
						upValue.date = null;
					}
				} else {
					upValue.specified = 'year';
					upValue.month = upValue.date = null;
				}
			} else {
				upValue.specified = 'none';
			}
			if (upValue.specified == 'date' && upValue.date > 28) {
				var d = new Date('January 1 2001');
				d.setFullYear(upValue.year);
				d.setMonth(upValue.month - 1);
				d.setDate(upValue.date);
				if (d.getDate() != upValue.date) {
					d.setDate(0);
					upValue.date = d.getDate();
				}
			}
			if (upValue.specified == 'date' && this.props.withoutYear) {
				var x = new Date('January 1 2001');
				x.setFullYear(new Date().getFullYear());
				x.setMonth(upValue.month - 1);
				x.setDate(upValue.date);
				if (x < new Date()) upValue.year = 1 + new Date().getFullYear();
			}
			this.setState({ inputDate: upValue });
			this.props.setValue(upValue);
		}
	}]);

	return DateField;
}(_base2.default);

exports.default = DateField;

var View = exports.View = function (_React$Component) {
	_inherits(View, _React$Component);

	function View() {
		_classCallCheck(this, View);

		return _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).apply(this, arguments));
	}

	_createClass(View, [{
		key: 'render',
		value: function render() {
			var r = DateField.View.format(this.props.date);
			if (r) return React.createElement(
				'span',
				null,
				r
			);
			return null;
		}
	}], [{
		key: 'format',
		value: function format(date, _ref) {
			var _ref$ignoreYear = _ref.ignoreYear,
			    ignoreYear = _ref$ignoreYear === undefined ? false : _ref$ignoreYear,
			    _ref$defaultValue = _ref.defaultValue,
			    defaultValue = _ref$defaultValue === undefined ? null : _ref$defaultValue;

			if (!date) {
				return defaultValue;
			}

			switch (date.specified) {
				case 'none':
					return defaultValue;

				case 'year':
					if (ignoreYear) return defaultValue;
					return date.year;

				case 'month':
					if (ignoreYear) return MonthList.monthName(date.month);
					return MonthList.monthName(date.month) + ' ' + date.year;

				default:
					if (ignoreYear) return MonthList.monthName(date.month) + ' ' + date.date;
					return MonthList.monthName(date.month) + ' ' + date.date + ' ' + date.year;
			}

			return defaultValue;
		}
	}, {
		key: 'name',
		get: function get() {
			return "DateField.View";
		}
	}]);

	return View;
}(React.Component);

DateField.View = View;